module.exports = __webpack_public_path__ + "img/circles.4e3c276c.png";